import React, { useState, useRef, useMemo } from 'react';
import Utils from 'shared/utils';
import { FTUE_STEPS_KEYS } from 'shared/constants';
import { generateGameListData } from 'shared/components/GamePage/utils';
import GameTile from '../GameTile';
import CustomScrollBar from '../CustomScrollBar';
import { MainContainer, getScrollBarConfig } from './styles';
import './scrollBarStyles.scss';
import Banner from '../Banner/Banner';
import { checkIfBannersEnabled } from 'shared/components/GamePage/utils';

const Home = props => {
  const {
    pagedGames,
    pageNumber,
    navigation,
    ftueStep,
    gameIndex,
    hasPromotions,
    lobbyBanners,
    lobbyPromotions,
    trigger,
  } = props;

  const [scrolling, setScrolling] = useState(false);
  const [updateKey, setUpdateKey] = useState(0);

  const gameTileRef = useRef(null);
  const updateScrollInstance = useRef(() => null);
  const prevFtueStepRef = useRef(ftueStep);

  const { gameList, totalGamesCount } = useMemo(() => {
    return generateGameListData(pagedGames, pageNumber, ftueStep);
  }, [pagedGames, pageNumber, ftueStep]);

  const triggerScrollUpdate = () => {
    setUpdateKey(prev => prev + 1);
  };

  const lobbyPromotionsLength = lobbyPromotions?.length;
  const lobbyBannersLength = lobbyBanners?.length;
  const bannersExist = lobbyBannersLength > 0;
  const showBanner = checkIfBannersEnabled(bannersExist);

  const scrollBarConfig = getScrollBarConfig(
    ftueStep,
    gameIndex,
    hasPromotions,
    totalGamesCount,
    showBanner,
    lobbyPromotionsLength,
    lobbyBannersLength
  );

  if (prevFtueStepRef.current === FTUE_STEPS_KEYS.HIGHLIGHT_A_GAME && ftueStep !== FTUE_STEPS_KEYS.HIGHLIGHT_A_GAME) {
    scrollBarConfig.scrollToPosition = null;
  }
  prevFtueStepRef.current = ftueStep;

  return (
    <CustomScrollBar
      updateScrollInstance={updateScrollInstance}
      updateKey={updateKey}
      onScrollCallback={() => setScrolling(!scrolling)}
      {...scrollBarConfig}
    >
      <MainContainer>
        {showBanner && (
          <Banner
            navigation={navigation}
            lobbyBanners={lobbyBanners}
            scrolling={scrolling}
            updateScrollInstance={updateScrollInstance}
            triggerScrollUpdate={triggerScrollUpdate}
          />
        )}
        {gameList.map((panelList, indexPaged) => {
          return (
            <div className="live-panel-grid" key={indexPaged}>
              {!Utils.isEmpty(panelList) &&
                panelList.map((item, index) => {
                  return (
                    item && (
                      <GameTile
                        gameTileRef={gameTileRef}
                        highlightedForOnboarding={index === 0 && indexPaged === 0}
                        itemData={{ ...item }}
                        key={index}
                        navigation={navigation}
                        trigger={trigger}
                      />
                    )
                  );
                })}
            </div>
          );
        })}
      </MainContainer>
    </CustomScrollBar>
  );
};

export default Home;
